import { Diagnostic, Rule } from "@siteimprove/alfa-act";
import { DOM, Node } from "@siteimprove/alfa-aria";
import { Query } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { Err, Ok } from "@siteimprove/alfa-result";
import * as dom from "@siteimprove/alfa-dom";
import { expectation } from "../common/act/expectation.js";
import { Scope, Stability } from "../tags/index.js";
const { isIncludedInTheAccessibilityTree } = DOM;
const { and } = Predicate;
const { getElementDescendants } = Query;
export default Rule.Atomic.of({
    uri: "https://alfa.siteimprove.com/rules/sia-r54",
    tags: [Scope.Component, Stability.Stable],
    evaluate({ device, document }) {
        return {
            applicability() {
                return getElementDescendants(document, dom.Node.fullTree).filter(and(isIncludedInTheAccessibilityTree(device), (element) => Node.from(element, device)
                    .attribute("aria-live")
                    .some((attribute) => attribute.value === "assertive"), (element) => !getElementDescendants(element, dom.Node.fullTree).isEmpty()));
            },
            expectations(target) {
                return {
                    1: expectation(Node.from(target, device)
                        .attribute("aria-atomic")
                        .some((attribute) => attribute.value.toLowerCase() === "true"), () => Outcomes.IsAtomic, () => Outcomes.IsNotAtomic),
                };
            },
        };
    },
});
/**
 * @public
 */
export var Outcomes;
(function (Outcomes) {
    Outcomes.IsAtomic = Ok.of(Diagnostic.of("The assertive region is atomic"));
    Outcomes.IsNotAtomic = Err.of(Diagnostic.of("The assertive region is not atomic"));
})(Outcomes || (Outcomes = {}));
//# sourceMappingURL=rule.js.map